import { render, staticRenderFns } from "./BlockProperties.vue?vue&type=template&id=7f216eae&scoped=true&"
import script from "./BlockProperties.vue?vue&type=script&lang=js&"
export * from "./BlockProperties.vue?vue&type=script&lang=js&"
import style0 from "./BlockProperties.vue?vue&type=style&index=0&id=7f216eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f216eae",
  null
  
)

export default component.exports